import React, { Component } from 'react'

import ContactAddress from '../ContactAddress'

import Map from '../Map'

class SimpleContact extends Component {
    render() {
        const { css, data, content, logoInverted } = this.props

        return (
            <div className="container">
                <div className="row">
                <div className={`col-lg-12 ${css} pb-4`} ></div>
                <div className="text-center" style={{ margin: 'auto' }}>
                    {content.title && <h2 className="text-center lined">{content.title}</h2>}
                </div>
                </div>
                <div className="row">
                <div className="col-md-4 pb-4">
                        <ContactAddress data={data} content={content} logoInverted={logoInverted} />
                    </div>
                    <div className="col-md-8 pb-4">
                        <Map map_src={content.address.map_src} />
                    </div>
                </div>
            </div>
        )
    }
}

export { SimpleContact }


// WEBPACK FOOTER //
// ./src/components/sections/SimpleContact.js